import React from "react"
import Tag from './svg/tag'

const MonitorTag = ({ currentDesign, tag, bannerDisplay }) => {
  let color
  switch(currentDesign.case[0].color) {
    case 'black':
      color = "#A7A9AC"
      break;
    case 'splatter':
      color = "#3A52A3"
      break;
    case 'sea':
      color = "#00A9C6"
      break;
    case 'desert':
      color = "#26232E"
      break;
    default:
      color = '#26232E'
  }
  return (
    <div className="monitor monitor__tag">
      <div className="tag">
        <Tag color={currentDesign.case[8].color} />
        <div style={{color: color}} className="tag__text iconfont"><pre>{tag}</pre></div>
      </div>
    </div>
  )
}

export default MonitorTag
